import { render, staticRenderFns } from "./PageViolationReportsSummary.vue?vue&type=template&id=2309ea67&"
import script from "./PageViolationReportsSummary.vue?vue&type=script&lang=ts&"
export * from "./PageViolationReportsSummary.vue?vue&type=script&lang=ts&"
import style0 from "./PageViolationReportsSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports